import React, { useState, Fragment, useEffect, useCallback } from "react";
import { XIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { useFileUpload } from "use-file-upload";
import { Menu, Transition } from "@headlessui/react";
import "./ChatRow.css";
import FriendList from "./FriendListGroup";
import backendService from "../services.js/backendService";
import toastProp from "../global/toastProps";
import { toast } from "react-toastify";
import axios from "axios";
import { PuffLoader } from "react-spinners";
import { data } from "autoprefixer";
import ImageViewer from "react-simple-image-viewer";
import { ShimmerCategoryItem } from "react-shimmer-effects";

function QuipComponent() {
  return Array.apply(null, { length: 5 }).map((e, i) => (
    <ShimmerCategoryItem
      key={i}
      hasImage
      imageType="circular"
      imageWidth={56}
      imageHeight={56}
      contentCenter
      text
    />
  ));
}
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function GroupSettingsModal({ ShowSettingsModal, userInfo, clicked, refresh }) {
  const [file, selectFile] = useFileUpload();
  const [chevronIcon, setChevronIcon] = useState(false);
  const [members, setMembers] = useState([]);
  const [name, setName] = useState(userInfo.groupName);
  const [description, setDescription] = useState(userInfo.groupDescription);
  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [membersLoading, setMembersLoading] = useState(false);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback(() => {
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setIsViewerOpen(false);
  };

  const getFriendList = (data) => {
    setSelectedMembers(data);
  };
  const loadGroupData = async () => {
    try {
      setMembersLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/getgroupinfo/${userInfo._id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      setMembers(response.data.groupInfo.members);
      setName(response.data.groupInfo.groupName);
      setDescription(response.data.groupInfo.groupDescription);
      setMembersLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const hoverAdmin = (id) => {
    if (userInfo.groupAdmin.includes(id) && userInfo.groupAdmin.length > 1) {
      return true;
    } else if (
      userInfo.groupAdmin.includes(id) &&
      userInfo.groupAdmin.length === 1
    ) {
      return false;
    }
    return true;
  };
  const addMembers = async () => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/addmember/${userInfo._id}`,
        {
          members: selectedMembers,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      setLoading(false);
     
      window.location.reload(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const changeGroupName = async () => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/changegroupname/${userInfo._id}`,
        {
          groupName: groupName,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      toast.success(response.data.message, toastProp);
      window.location.reload(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const changeGroupDescription = async () => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/changegroupdescription/${userInfo._id}`,
        {
          groupDescription: groupDescription,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      toast.success(response.data.message, toastProp);
      await loadGroupData();
      window.location.reload(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const removeMember = async (id) => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/removemember/${userInfo._id}`,
        {
          _id: id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      await loadGroupData();
      window.location.reload(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const makeAdmin = async (id) => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/makeadmin/${userInfo._id}`,
        {
          _id: id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      window.location.reload(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const removeAdmin = async (id) => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/removeadmin/${userInfo._id}`,
        {
          _id: id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      window.location.reload(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const leaveGroup = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/leavegroup/${userInfo._id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      window.location.reload(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      
      toast.error(error.response.data.Status, { theme: "light" });
    }
  };

  useEffect(async () => {
    await loadGroupData();
  }, []);

  return (
    <>
      {isViewerOpen && (
        <ImageViewer
          src={[userInfo.profilePicture.filePath]}
          currentIndex={0}
          onClose={closeImageViewer}
          backgroundStyle={{
            backgroundColor: "rgba(0,0,0,0.9)",
            zIndex: "50",
          }}
        />
      )}
      <div className="justify-center items-center my-4 flex   fixed inset-0 z-40 outline-none focus:outline-none">
        <div className="w-11/12 sm:w-3/4 md:w-1/2 lg:w-2/5 xl:w-1/3 h-auto flex justify-center items-center overflow-x-hidden overflow-y-auto max-w-lg rounded-lg shadow-md shadow-black">
          {/*content*/}
          <div className=" rounded-lg shadow-lg overflow-x-hidden overflow-y-auto chat__container relative flex flex-col h-auto max-h-[85vh] w-full  outline-none focus:outline-none">
            {/*header*/}
            <div
              className={
                loading
                  ? "flex justify-between bg-palette_color2  pt-2 pr-2 sticky z-40 top-0"
                  : "flex justify-between bg-palette_color2  pt-2 pr-2 sticky z-40 top-0"
              }
            >
              {loading ? (
                <div className="flex items-center justify-center pl-2 ">
                  <div className="w-full h-full flex items-center justify-center text-palette_color1">
                    <PuffLoader size={30} color={"#0077b6"} loading={loading} />
                    Updating ...
                  </div>
                </div>
              ) : userInfo.groupAdmin.includes(
                  backendService.getLoggedInUser()._id
                ) ? (
                <h3 className="text-xl pl-4 font-robo mb-2 text-primary">
                  Group Settings
                </h3>
              ) : (
                <h3 className="text-xl pl-4 mb-2 font-robo  text-primary">
                  Group Details
                </h3>
              )}
              <div
                className="h-7 w-7  flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full"
                onClick={() => ShowSettingsModal(false)}
              >
                <XIcon className="h-5 w-5  " aria-hidden="true" />
              </div>
            </div>
            <div className="flex items-center justify-center  h-[8%] pt-4 bg-background"></div>
            {/*body*/}
            <div className="   bg-background h-auto">
              <div className="flex-col items-center justify-center h-full">
                <div className="flex flex-col items-center justify-center w-full h-auto">
                  {file ? (
                    <div className="flex justify-center items-center m-2 w-[100%]">
                      <img
                        alt="Profile"
                        className="rounded-full h-44 w-44"
                        src={file.source}
                      />
                    </div>
                  ) : (
                    <div className="flex justify-center items-center m-2 w-[100%]">
                      <img
                        alt="Profile"
                        className="rounded-full h-44 w-44 cursor-pointer"
                        src={
                          userInfo.profilePicture
                            ? userInfo.profilePicture.filePath
                            : require("../assets/people.png")
                        }
                        onClick={() => openImageViewer()}
                      />
                    </div>
                  )}
                  {userInfo.groupAdmin.includes(
                    backendService.getLoggedInUser()._id
                  ) && (
                    <button
                      type="button"
                      className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                      onClick={() =>
                        selectFile(
                          { accept: "image/*" },
                          async ({ source, name, size, file }) => {
                            const id = toast.loading("Uploading ...", {
                              theme: "light",
                            });
                            const formData = new FormData();
                            formData.append("file", file);
                            formData.append("conversationId", userInfo._id);
                            await axios
                              .post(
                                `${process.env.REACT_APP_URL}/changegroupprofilepicture`,
                                formData,
                                {
                                  headers: {
                                    "Content-Type": "multipart/form-data",
                                    "x-auth-token": backendService.getToken(),
                                  },
                                }
                              )
                              .then((res) => {
                                // clicked(new Date());
                                window.location.reload(false);
                                toast.update(id, toastProp("Uploaded", true));
                              })
                              .catch((err) => {
                                toast.update(
                                  id,
                                  toastProp("Upload Failed", false)
                                );
                              });
                          }
                        )
                      }
                    >
                      {"Upload"}
                    </button>
                  )}
                </div>
                <div className="flex-col justify-center items-center h-auto w-full px-6">
                  <div className=" w-full h-auto ">
                    <form action="#" method="POST">
                      <div className="col-span-6 sm:col-span-3">
                        {/* Group Name Start */}
                        {userInfo.groupAdmin.includes(
                          backendService.getLoggedInUser()._id
                        ) ? (
                          <>
                            <div className="flex-col justify-between items-center pb-2">
                              <label className="block text-base font-robo text-primary ">
                                Group name
                              </label>
                              <input
                                type="text"
                                name="groupName"
                                id="groupName"
                                autoComplete="off"
                                className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                                placeholder={name ? name : "Enter Group Name"}
                                onChange={(e) => setGroupName(e.target.value)}
                                required
                              />
                            </div>
                            <div className="flex justify-end">
                              <button
                                className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                                type="button"
                                disabled={loading}
                                onClick={async () => {
                                  if (groupName.length > 3) {
                                    await changeGroupName();
                                  } else {
                                    toast.error(
                                      "Group name must be at least 3 characters",
                                      {
                                        theme: "light",
                                      }
                                    );
                                  }
                                }}
                              >
                                Update Name
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="flex justify-center items-center">
                            <div>
                              <h3 className="block text-xl text-center font-robo text-primary ">
                                {name}
                              </h3>
                              {/* <h3 className="block text-md text-center font-robo text-secondary ">
                                Group name
                              </h3> */}
                            </div>
                          </div>
                        )}
                        {/* Group Name End */}
                        {/* Group Description Start */}
                        {userInfo.groupAdmin.includes(
                          backendService.getLoggedInUser()._id
                        ) ? (
                          <>
                            <div className="flex-col justify-between items-center py-2">
                              <label className="block text-base font-robo text-primary ">
                                Description
                              </label>
                              <textarea
                                type="text"
                                name="groupDescription"
                                id="groupDescription"
                                autoComplete="off"
                                className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                                placeholder={
                                  description
                                    ? description
                                    : "Enter description"
                                }
                                onChange={(e) =>
                                  setGroupDescription(e.target.value)
                                }
                                required
                              />{" "}
                            </div>
                            <div className="flex justify-end">
                              <button
                                className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                                type="button"
                                disabled={loading}
                                onClick={async () => {
                                  if (groupDescription.length > 20) {
                                    await changeGroupDescription();
                                  } else {
                                    toast.error(
                                      "Description must be at least 20 characters",
                                      {
                                        theme: "light",
                                      }
                                    );
                                  }
                                }}
                              >
                                Update Description
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="mt-2 flex-wrap justify-center items-center ">
                            <h3 className="block text-sm text-center font-robo text-secondary ">
                              Description
                            </h3>
                            <p className="block text-md pb-1 font-robo text-primary text-center text-ellipsis overflow-hidden  ">
                              {description ? description : "No Description"}
                            </p>
                          </div>
                        )}
                        {/* Group Description End */}
                      </div>
                    </form>
                    {/* Add User Start */}
                    {userInfo.groupAdmin.includes(
                      backendService.getLoggedInUser()._id
                    ) && (
                      <>
                        <div className="flex-col justify-between items-center py-2">
                          <h3 className="block text-base font-robo text-primary ">
                            Add Members
                          </h3>
                          <FriendList
                            ID={userInfo._id}
                            friendList={getFriendList}
                          />
                        </div>
                        <div className="flex justify-end">
                          <button
                            className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                            type="button"
                            disabled={loading}
                            onClick={async () => {
                              if (selectedMembers.length > 0) {
                                await addMembers();
                              } else {
                                toast.error(
                                  "Please select at least one member",
                                  {
                                    theme: "light",
                                  }
                                );
                              }
                            }}
                          >
                            Add to group
                          </button>
                        </div>
                      </>
                    )}
                    {/* Add User End */}
                  </div>

                  <div className="w-full bg-palette_color2 h-auto ">
                    <h3 className="text-primary font-robo text-xl pl-4 ">
                      Members
                    </h3>
                    <div className=" bg-palette_color2 rounded-md">
                      <div className="h-60 overflow-y-auto overflow-x-hidden w-[100%] chat__container bg-palette_color2">
                        {/* Group Member Row Start */}

                        {!membersLoading ? (
                          members.map((member) => (
                            <div
                              key={member.user._id}
                              className="bg-palette_color2 h-[60px] rounded-lg shadow flex items-center m-3  text-primary hover:bg-palette_color1 hover:text-palette_color2"
                              onMouseEnter={() =>
                                setChevronIcon({
                                  id: member.user._id,
                                  state: true,
                                })
                              }
                              onMouseLeave={() => setChevronIcon(false)}
                            >
                              <div className="flex items-center justify-center w-[20%]">
                                <img
                                  className="rounded-full w-[40px] h-[40px] cursor-pointer"
                                  src={
                                    member.user.profilePicture?.filePath
                                      ? member.user.profilePicture.filePath
                                      : require("../assets/boredApe.png")
                                  }
                                  alt="Profile"
                                />
                              </div>
                              <div className="flex flex-col w-[85%] mr-3">
                                <div className="flex items-center w-full">
                                  <h3 className=" font-robo text-md ">
                                    {member.user.firstname +
                                      " " +
                                      member.user.lastname}
                                  </h3>
                                  {member.isAdmin && (
                                    <h5 className="text-xs border-none text-background font-robo  bg-palette_color4 rounded-md px-[4px] py-[1px] ml-1">
                                      Admin
                                    </h5>
                                  )}
                                </div>
                                <div
                                  key={member.user._id}
                                  className="flex items-center justify-between"
                                >
                                  <h3 className="text-sm   font-robo mr-1">
                                    @{member.user.username}
                                  </h3>

                                  {chevronIcon &&
                                  chevronIcon.id === member.user._id &&
                                  hoverAdmin(chevronIcon.id) &&
                                  !userInfo.groupAdmin.length < 1 &&
                                  userInfo.groupAdmin.includes(
                                    backendService.getLoggedInUser()._id
                                  ) ? (
                                    <div className="flex items-center justify-center cursor-pointer h-7 w-7 relative">
                                      <Menu
                                        as="div"
                                        className="absolute items-center justify-center inline-block text-left"
                                      >
                                        <Menu.Button>
                                          <div className="h-7 w-7 flex items-center justify-center cursor-pointer  hover:bg-palette_color1 hover:text-palette_color2 text-palette_color2 hover:rounded-full">
                                            <ChevronDownIcon
                                              className="h-5 w-5 "
                                              aria-hidden="true"
                                            />
                                          </div>
                                        </Menu.Button>

                                        <Transition
                                          as={Fragment}
                                          enter="transition ease-out duration-100"
                                          enterFrom="transform opacity-0 scale-95"
                                          enterTo="transform opacity-100 scale-100"
                                          leave="transition ease-in duration-75"
                                          leaveFrom="transform opacity-100 scale-100"
                                          leaveTo="transform opacity-0 scale-95"
                                        >
                                          <Menu.Items className="origin-top-center absolute  bottom-[-13px] left-[-190px] mt-1 w-56 rounded-md shadow-lg bg-palette_color2 focus:outline-none z-10">
                                            {member.isAdmin &&
                                              userInfo.groupAdmin.length >
                                                1 && (
                                                <Menu.Item>
                                                  {({ active }) => (
                                                    <a
                                                      href="#"
                                                      className={classNames(
                                                        active
                                                          ? "bg-palette_color1 text-palette_color2 rounded-md"
                                                          : "text-palette_color1",
                                                        "block px-4 py-2 text-sm font-robo "
                                                      )}
                                                      onClick={async () => {
                                                        await removeAdmin(
                                                          member.user._id
                                                        );
                                                      }}
                                                    >
                                                      Remove as admin
                                                    </a>
                                                  )}
                                                </Menu.Item>
                                              )}
                                            {!member.isAdmin && (
                                              <Menu.Item>
                                                {({ active }) => (
                                                  <a
                                                    href="#"
                                                    className={classNames(
                                                      active
                                                        ? "bg-palette_color1 text-palette_color2 rounded-md"
                                                        : "text-palette_color1",
                                                      "block px-4 py-2 text-sm font-robo "
                                                    )}
                                                    onClick={async () => {
                                                      await removeMember(
                                                        member.user._id
                                                      );
                                                    }}
                                                  >
                                                    Remove Member
                                                  </a>
                                                )}
                                              </Menu.Item>
                                            )}
                                            {!member.isAdmin && (
                                              <Menu.Item>
                                                {({ active }) => (
                                                  <a
                                                    href="#"
                                                    className={classNames(
                                                      active
                                                        ? "bg-palette_color1 text-palette_color2 rounded-md"
                                                        : "text-palette_color1",
                                                      "block px-4 py-2 text-sm font-robo "
                                                    )}
                                                    onClick={async () => {
                                                      await makeAdmin(
                                                        member.user._id
                                                      );
                                                    }}
                                                  >
                                                    Make Admin
                                                  </a>
                                                )}
                                              </Menu.Item>
                                            )}
                                          </Menu.Items>
                                        </Transition>
                                      </Menu>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <QuipComponent />
                        )}
                        {/* Group Member Row End */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*footer*/}
            <div className="flex items-center h-[10%] w-full justify-end p-3 pt-3 pr-6  rounded-b bg-palette_color2">
              <button
                type="button"
                className="bg-red border-[1px] border-red mt-1 hover:bg-palette_color2 text-white hover:text-red  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-red  ease-linear transition-all duration-500"
                onClick={async () => {
                  await leaveGroup();
                }}
              >
                Leave Group
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-50  fixed inset-0 z-20 bg-black"></div>
    </>
  );
}

export default GroupSettingsModal;
